import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { mainSiteUrl } from '@/mocks/homeData';

interface PlaceholderPageProps {
  title: string;
}

export default function PlaceholderPage({ title }: PlaceholderPageProps) {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main className="pt-28 pb-16 md:pt-36 md:pb-20">
        <div className="max-w-3xl mx-auto px-4 md:px-6 text-center">
          <nav className="flex items-center justify-center gap-2 text-xs text-foreground-400 mb-8 flex-wrap">
            <Link to="/" className="hover:text-primary-600 transition-colors">Home</Link>
            <span>/</span>
            <span className="text-foreground-600">{title}</span>
          </nav>

          <div className="w-16 h-16 rounded-2xl bg-primary-100 flex items-center justify-center mx-auto mb-6">
            <i className="ri-file-text-line text-2xl text-primary-600"></i>
          </div>

          <h1 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-4">
            {title}
          </h1>
          <p className="text-foreground-500 text-sm md:text-base max-w-lg mx-auto mb-8 leading-relaxed">
            This page is currently being developed with original, research-backed content about BaseTao Spreadsheet. 
            We are working on comprehensive articles and resources to help you make informed shopping decisions. 
            Please check back soon or explore our other available guides.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/basetao-spreadsheet/"
              className="px-6 py-2.5 bg-primary-500 text-background-50 rounded-lg text-sm font-semibold hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap"
            >
              Read Spreadsheet Guide
            </Link>
            <Link
              to="/"
              className="px-6 py-2.5 text-foreground-600 text-sm font-medium hover:text-primary-600 transition-colors duration-200 whitespace-nowrap"
            >
              Back to Homepage
            </Link>
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="px-6 py-2.5 text-foreground-600 text-sm font-medium hover:text-accent-600 transition-colors duration-200 whitespace-nowrap"
            >
              Visit BaseTao Spreadsheet &rarr;
            </a>
          </div>
        </div>
      </main>
      <Footer />

      {/* Schema.org WebPage */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebPage',
            name: title,
            description: `Informational page about ${title} — part of the BaseTao Sheet independent educational resource.`,
            url: `https://basetaosheet.team${window.location.pathname}`,
            isPartOf: {
              '@type': 'WebSite',
              name: 'BaseTao Sheet',
              url: 'https://basetaosheet.team/',
            },
          }),
        }}
      />
    </div>
  );
}